<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    width="1000px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider
      >{{ $t('SettingBaseDataConfig.addAndEdit.msg') }}
      <!-- <template slot="right">
        <el-button>{{ $t('operationLogText') }}</el-button>
      </template> -->
    </BjDivider>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.channel')" prop="channelCode">
        <BjSelectLov v-model="form.channelCode" lov-code="SCHL.CHANNEL_TYPE" />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.logo')" prop="systemFlagCode">
        <BjSelectLov v-model="form.systemFlagCode" lov-code="THIRD.CONFIG_FLAG" />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.applicationName')" prop="appName">
        <BjInput
          v-model="form.appName"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.applicationType')" prop="appType">
        <BjInput
          v-model="form.appType"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="app_key" prop="appKey">
        <BjInput v-model="form.appKey" :maxlength="100" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="app_secret" prop="appSecret">
        <BjInput v-model="form.appSecret" :maxlength="100" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.authorize')" prop="authUrl">
        <BjInput
          v-model="form.authUrl"
          :maxlength="MAX_LENGTH.REMARK"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.otherAddress')" prop="otherUrl">
        <BjInput
          v-model="form.otherUrl"
          :maxlength="MAX_LENGTH.REMARK"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.api')" prop="apiServiceUrl">
        <BjInput
          v-model="form.apiServiceUrl"
          :maxlength="MAX_LENGTH.REMARK"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>

    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.callbackAddress')" prop="callBackUrl">
        <BjInput
          v-model="form.callBackUrl"
          :maxlength="MAX_LENGTH.REMARK"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.certificate')" prop="certificateFlow">
        <BjInput
          v-model="form.certificateFlow"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.authorizeAccount')" prop="authAccount">
        <BjInput
          v-model="form.authAccount"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.openPlatform')" prop="platformAddress">
        <BjInput
          v-model="form.platformAddress"
          :maxlength="MAX_LENGTH.REMARK"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.account')" prop="account">
        <BjInput
          v-model="form.account"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataConfig.addAndEdit.remark')" prop="remark">
        <BjTextarea v-model="form.remark" :placeholder="$t('SettingBaseDataConfig.addAndEdit.remark')" />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { baseDataApi } from '@/api';
import { validURL } from '@/utils/validate';

const getDefaultForm = () => {
  return {
    account: null,
    appKey: null,
    appName: null,
    appSecret: null,
    appType: null,
    authAccount: null,
    authUrl: null,
    otherUrl: null,
    apiServiceUrl: null,
    callBackUrl: null,
    certificateFlow: null,
    channelCode: null,
    deleteFlag: 0,
    platformAddress: null,
    remark: null,
    status: 1,
    systemFlagCode: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        channelCode: [{ required: true, message: this.$t('SettingBaseDataConfig.addAndEdit.channelText'), trigger: 'change' }],
        systemFlagCode: [{ required: true, message: this.$t('SettingBaseDataConfig.addAndEdit.systemText'), trigger: 'blur' }],
        appName: [{ required: true, message: this.$t('SettingBaseDataConfig.addAndEdit.applicationNameText'), trigger: 'blur' }],
        appType: [{ required: true, message: this.$t('SettingBaseDataConfig.addAndEdit.applicationTypeText'), trigger: 'blur' }],
        appKey: [{ required: true, message: this.$t('SettingBaseDataConfig.addAndEdit.app_keyText'), trigger: 'blur' }],
        appSecret: [{ required: true, message: this.$t('SettingBaseDataConfig.addAndEdit.app_secretText'), trigger: 'blur' }],
        authUrl: [{ validator: this.validatorUrl, trigger: 'blur' }],
        otherUrl: [{ validator: this.validatorUrl, trigger: 'blur' }],
        apiServiceUrl: [{ validator: this.validatorUrl, trigger: 'blur' }],
        callBackUrl: [
          { required: true, message: this.$t('SettingBaseDataConfig.addAndEdit.callbackAddressText') },
          { validator: this.validatorUrl, trigger: 'blur' },
        ],
        platformAddress: [{ validator: this.validatorUrl, trigger: 'blur' }],
      },
      appKey: null,
      appSecret: null,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    validatorUrl (rules, value, callback) {
      if (!value) {
        if (rules.required) {
          callback(new Error(this.$t('PleaseAddressText')));
        } else {
          callback();
        }
      } else {
        if (!validURL(value)) {
          callback(new Error(this.$t('IncorrectAddressFormatText')));
        } else {
          callback();
        }
      }
    },

    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle((this.isEdit ? this.$t('editText') : this.$t('addText')) + this.$t('SettingBaseDataConfig.addAndEdit.valueSet'));
      this.form = Object.assign(getDefaultForm(), info || {});
      if (this.isEdit) {
        this.appKey = this.form.appKey;
        this.appSecret = this.form.appSecret;
      }
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
        if (API_DATA.appKey === this.appKey) delete API_DATA.appKey;
        if (API_DATA.appSecret === this.appSecret) delete API_DATA.appSecret;
      }
      this.sendApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },
    sendApi(API_DATA) {
      baseDataApi[this.isEdit ? 'putThirdConfigs' : 'addThirdConfigs'](API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
